import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, Route, Routes, useNavigate } from 'react-router';
import { Landing } from '../features/landing/Landing';
import { Lobby } from '../features/lobby/Lobby';
import { Hq } from '../features/hq/Hq';
import { Settings } from '../features/settings/Settings';
import { useAuth } from './stores/auth';

function NotFound() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-[14px] text-txt">{t('errors.common.notFound')}</p>
      <Link to="/" className="text-[13px] text-amber">
        {t('common.action.back')}
      </Link>
    </main>
  );
}

/** Экран мира требует сессии: без неё сокет всё равно не откроется. */
function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  return <>{children}</>;
}

/** /play - заглушка Фазы 0: автоподбор мира появится в Фазе 4 (01 §3). */
function Play() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate('/lobby', { replace: true });
  }, [navigate]);
  return null;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/play" element={<Play />} />
      <Route path="/lobby" element={<Lobby />} />
      <Route
        path="/w/:id"
        element={
          <RequireAuth>
            <Hq />
          </RequireAuth>
        }
      />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
